import {jsxs as $2HmYz$jsxs, jsx as $2HmYz$jsx, Fragment as $2HmYz$Fragment} from "react/jsx-runtime";
import $2HmYz$classnames from "classnames";
import {useState as $2HmYz$useState, useId as $2HmYz$useId, useEffect as $2HmYz$useEffect, forwardRef as $2HmYz$forwardRef, useRef as $2HmYz$useRef, isValidElement as $2HmYz$isValidElement} from "react";
import {SVVAlert as $2HmYz$SVVAlert} from "@komponentkassen/svv-alert";
import {SVVConditionalWrapper as $2HmYz$SVVConditionalWrapper} from "@komponentkassen/svv-layout";
import {Search as $2HmYz$Search} from "@komponentkassen/svv-icons";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $2824c2d2eb112f7e$exports = {};

$parcel$export($2824c2d2eb112f7e$exports, "SVVTextInput", () => $2824c2d2eb112f7e$export$9a9ecced0a4bade6);




var $e58ee6a643f23063$exports = {};

$parcel$export($e58ee6a643f23063$exports, "SVVFormError", () => $e58ee6a643f23063$export$17503d092977c384);


function $e58ee6a643f23063$export$17503d092977c384({ children: children , className: className , id: id  }) {
    return /*#__PURE__*/ (0, $2HmYz$jsx)("div", {
        className: className,
        id: id,
        children: /*#__PURE__*/ (0, $2HmYz$jsx)("div", {
            className: "svv-form-error",
            children: children
        })
    });
}


var $25ca7d7dcfe715d6$exports = {};

$parcel$export($25ca7d7dcfe715d6$exports, "SVVLabel", () => $25ca7d7dcfe715d6$export$7aa8239a4d00617e);




var $14e7cb777ecf9dfd$exports = {};

$parcel$export($14e7cb777ecf9dfd$exports, "SVVPopover", () => $14e7cb777ecf9dfd$export$8eb2fb0b97d123d3);


function $14e7cb777ecf9dfd$export$8eb2fb0b97d123d3({ explanationText: explanationText , closeText: closeText = "Lukk" , title: title , ariaLabel: ariaLabel = "Ordforklaring for " , headingLevel: headingLevel = "h3"  }) {
    const [open, setOpen] = (0, $2HmYz$useState)(false);
    const containerId = (0, $2HmYz$useId)();
    const popoverRef = (0, $2HmYz$useRef)(null);
    const triggerRef = (0, $2HmYz$useRef)(null);
    const HLevel = headingLevel;
    const handleOutsideClick = (event)=>{
        const { target: target  } = event;
        if (target instanceof Node) {
            if (!popoverRef.current?.contains(target) && event.target !== triggerRef.current) setOpen(false);
        }
    };
    (0, $2HmYz$useEffect)(()=>{
        document.addEventListener("click", handleOutsideClick, true);
        return ()=>{
            document.removeEventListener("click", handleOutsideClick, true);
        };
    }, []);
    const handleEscapeKey = (event)=>{
        if (event.key.toLowerCase() === "escape") setOpen(false);
    };
    const setArrowPlacement = ()=>{
        const left = triggerRef.current?.offsetLeft;
        let iconPos = 6;
        if (left) iconPos += left;
        const popover = document.getElementById(containerId);
        popover?.style.setProperty("--icon-position", `${iconPos}px`);
    };
    (0, $2HmYz$useEffect)(()=>{
        if (open) {
            document.addEventListener("keydown", handleEscapeKey, true);
            setArrowPlacement();
        }
        return ()=>{
            document.removeEventListener("keydown", handleEscapeKey, true);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $2HmYz$jsxs)("div", {
        className: "svv-popover-container",
        children: [
            /*#__PURE__*/ (0, $2HmYz$jsx)("button", {
                ref: triggerRef,
                type: "button",
                className: "svv-popover-trigger",
                "aria-controls": containerId,
                "aria-expanded": open,
                "aria-label": `${ariaLabel}${title}`,
                onClick: ()=>setOpen(!open)
            }),
            /*#__PURE__*/ (0, $2HmYz$jsxs)("div", {
                ref: popoverRef,
                id: containerId,
                className: "svv-helptext-container",
                hidden: !open,
                children: [
                    /*#__PURE__*/ (0, $2HmYz$jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $2HmYz$jsx)(HLevel, {
                                className: "svv-h6 svv-padding-bottom--px8",
                                style: {
                                    fontWeight: "600"
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0, $2HmYz$jsx)("button", {
                                className: "svv-popover__close-button",
                                type: "button",
                                onClick: ()=>setOpen(false),
                                "aria-label": closeText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2HmYz$isValidElement)(explanationText) ? explanationText : /*#__PURE__*/ (0, $2HmYz$jsx)("p", {
                        children: explanationText
                    })
                ]
            })
        ]
    });
}


function $25ca7d7dcfe715d6$export$7aa8239a4d00617e({ children: children1 , className: className , htmlFor: htmlFor , id: id , required: required , popoverText: popoverText , popoverTitle: popoverTitle  }) {
    return /*#__PURE__*/ (0, $2HmYz$jsxs)((0, $2HmYz$SVVConditionalWrapper), {
        condition: !!(popoverText && popoverTitle),
        // eslint-disable-next-line  @typescript-eslint/no-shadow
        renderWrapper: (children)=>/*#__PURE__*/ (0, $2HmYz$jsx)("div", {
                children: children
            }),
        children: [
            /*#__PURE__*/ (0, $2HmYz$jsxs)("label", {
                className: (0, $2HmYz$classnames)("svv-form-label", className, {
                    "svv-form-label--inline": popoverText
                }),
                htmlFor: htmlFor,
                id: id,
                children: [
                    children1,
                    " ",
                    required && /*#__PURE__*/ (0, $2HmYz$jsx)("span", {
                        "aria-hidden": "true",
                        children: " *"
                    })
                ]
            }),
            popoverTitle && popoverText && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $14e7cb777ecf9dfd$export$8eb2fb0b97d123d3), {
                title: popoverTitle,
                explanationText: popoverText
            })
        ]
    });
}




function $3360cc37f7f07341$export$393edc798c47379d({ content: content  }) {
    return /*#__PURE__*/ (0, $2HmYz$jsx)("p", {
        className: "svv-form-description",
        children: content
    });
}


function $2824c2d2eb112f7e$var$Component({ className: className , errorMessage: errorMessage , label: label , placeholder: placeholder , inputSize: inputSize = "medium" , id: id , required: required , type: type = "text" , maxLength: maxLength , maxLengthHelperText: maxLengthHelperText = "maks antall tegn er " , maxLengthWarning: maxLengthWarning = " tegn igjen til maks er n\xe5dd." , value: value , onChange: onChange , popoverText: popoverText , popoverTitle: popoverTitle , removeMargin: removeMargin = false , isFullWidth: isFullWidth = false , description: description , showWarning: showWarning = false , ...rest }, ref) {
    const [errorMessageId] = (0, $2HmYz$useState)(`feilmelding-${(0, $2HmYz$useId)()}`);
    const hasErrorMessage = !!errorMessage;
    const maxLengthLabel = maxLength ? `(${maxLengthHelperText} ${maxLength})` : "";
    const warningNumber = maxLength ? maxLength - 10 : null;
    const handleChange = (e)=>{
        onChange(e);
    };
    (0, $2HmYz$useEffect)(()=>{}, [
        ref
    ]);
    return /*#__PURE__*/ (0, $2HmYz$jsxs)("div", {
        className: (0, $2HmYz$classnames)("svv-form-element", {
            "svv-form-element--margin-bottom": !removeMargin,
            "svv-form-element--max-width": !isFullWidth
        }, className),
        children: [
            label && /*#__PURE__*/ (0, $2HmYz$jsxs)((0, $25ca7d7dcfe715d6$export$7aa8239a4d00617e), {
                htmlFor: id,
                required: required,
                popoverText: popoverText,
                popoverTitle: popoverTitle,
                children: [
                    label,
                    " ",
                    maxLengthLabel
                ]
            }),
            description && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $3360cc37f7f07341$export$393edc798c47379d), {
                content: description
            }),
            /*#__PURE__*/ (0, $2HmYz$jsx)("input", {
                id: id,
                className: (0, $2HmYz$classnames)("svv-form-input__text", {
                    "svv-form-input__text--error": hasErrorMessage,
                    "input--x-small": inputSize === "xsmall",
                    "input--small": inputSize === "small",
                    "input--medium": inputSize === "medium",
                    "input--large": inputSize === "large"
                }),
                placeholder: placeholder,
                ref: ref,
                "aria-invalid": hasErrorMessage,
                "aria-describedby": hasErrorMessage ? errorMessageId : undefined,
                required: required,
                type: type,
                value: value,
                onChange: handleChange,
                ...rest
            }),
            maxLengthHelperText && maxLength && /*#__PURE__*/ (0, $2HmYz$jsx)("div", {
                children: /*#__PURE__*/ (0, $2HmYz$jsxs)("p", {
                    children: [
                        value.length,
                        "/",
                        maxLength
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2HmYz$jsx)("div", {
                "aria-live": "assertive",
                children: errorMessage && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $e58ee6a643f23063$export$17503d092977c384), {
                    id: errorMessageId,
                    children: /*#__PURE__*/ (0, $2HmYz$jsx)("p", {
                        children: errorMessage
                    })
                })
            }),
            /*#__PURE__*/ (0, $2HmYz$jsx)("div", {
                children: showWarning && warningNumber && maxLength && !errorMessage && value.length > maxLength - 10 && /*#__PURE__*/ (0, $2HmYz$jsxs)((0, $2HmYz$SVVAlert), {
                    type: "info",
                    children: [
                        maxLength - value.length,
                        " ",
                        maxLengthWarning
                    ]
                })
            })
        ]
    });
}
const $2824c2d2eb112f7e$export$9a9ecced0a4bade6 = /*#__PURE__*/ (0, $2HmYz$forwardRef)($2824c2d2eb112f7e$var$Component);




var $7393724a49d31a75$exports = {};

$parcel$export($7393724a49d31a75$exports, "Radio", () => $7393724a49d31a75$export$d7b12c4107be0d61);


function $7393724a49d31a75$var$Component({ text: text , description: description , description2: description2 , description3: description3 , ariaDescribedby: ariaDescribedby , ...rest }, ref) {
    const id = (0, $2HmYz$useId)();
    const textId = (0, $2HmYz$useId)();
    const descriptionId = (0, $2HmYz$useId)();
    const hasDescription = description !== undefined || description2 !== undefined || description3 !== undefined;
    const describedByIds = [];
    if (hasDescription) describedByIds.push(descriptionId);
    if (ariaDescribedby) describedByIds.push(ariaDescribedby);
    return /*#__PURE__*/ (0, $2HmYz$jsxs)((0, $2HmYz$Fragment), {
        children: [
            /*#__PURE__*/ (0, $2HmYz$jsx)("input", {
                type: "radio",
                id: id,
                "aria-labelledby": textId,
                ref: ref,
                ...describedByIds.length > 0 && {
                    "aria-describedby": describedByIds.join(" ")
                },
                ...rest
            }),
            /*#__PURE__*/ (0, $2HmYz$jsxs)("label", {
                className: `svv-form-label${hasDescription ? " svv-label-grid" : ""}`,
                htmlFor: id,
                children: [
                    /*#__PURE__*/ (0, $2HmYz$jsx)("span", {
                        id: textId,
                        ...hasDescription && {
                            "aria-hidden": true
                        },
                        children: text
                    }),
                    hasDescription && /*#__PURE__*/ (0, $2HmYz$jsxs)("span", {
                        id: descriptionId,
                        children: [
                            description && /*#__PURE__*/ (0, $2HmYz$jsx)("span", {
                                className: "svv-label-description",
                                children: description
                            }),
                            description2 && /*#__PURE__*/ (0, $2HmYz$jsx)("span", {
                                className: "svv-label-description",
                                children: description2
                            }),
                            description3 && /*#__PURE__*/ (0, $2HmYz$jsx)("span", {
                                className: "svv-label-description",
                                children: description3
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $7393724a49d31a75$export$d7b12c4107be0d61 = /*#__PURE__*/ (0, $2HmYz$forwardRef)($7393724a49d31a75$var$Component);


var $0d88376077b9c7c1$exports = {};

$parcel$export($0d88376077b9c7c1$exports, "SVVRadioGroup", () => $0d88376077b9c7c1$export$734ace74a9d87553);






function $0d88376077b9c7c1$var$Component({ onChange: onChange , options: options , selected: selected , legend: legend , required: required = false , errorMessage: errorMessage = "" , name: name , direction: direction = "horizontal" , popoverText: popoverText , popoverTitle: popoverTitle , removeMargin: removeMargin = false , isFullWidth: isFullWidth , description: description  }) {
    const [feilmeldingId] = (0, $2HmYz$useState)(`feilmelding-${(0, $2HmYz$useId)()}`);
    return /*#__PURE__*/ (0, $2HmYz$jsxs)("fieldset", {
        className: (0, $2HmYz$classnames)("svv-form-element", {
            "svv-form-element--inline": direction === "horizontal",
            "svv-form-element--with-errors": errorMessage,
            "svv-form-element--margin-bottom": !removeMargin,
            "svv-form-element--max-width": !isFullWidth
        }),
        children: [
            /*#__PURE__*/ (0, $2HmYz$jsxs)("legend", {
                className: "svv-form-label",
                children: [
                    legend,
                    required && /*#__PURE__*/ (0, $2HmYz$jsx)("span", {
                        "aria-hidden": "true",
                        children: " *"
                    }),
                    popoverTitle && popoverText && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $14e7cb777ecf9dfd$export$8eb2fb0b97d123d3), {
                        title: popoverTitle,
                        explanationText: popoverText
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, $2HmYz$jsx)("p", {
                className: "svv-form-description",
                children: description
            }),
            options.map((o)=>/*#__PURE__*/ (0, $2HmYz$jsx)((0, $7393724a49d31a75$export$d7b12c4107be0d61), {
                    name: name,
                    onChange: onChange,
                    value: o.value,
                    text: o.text,
                    checked: o.value === selected,
                    required: required || false,
                    ariaDescribedby: errorMessage ? feilmeldingId : undefined,
                    disabled: o.disabled,
                    description: o.description,
                    description2: o.description2,
                    description3: o.description3,
                    ref: o.ref
                }, o.value)),
            /*#__PURE__*/ (0, $2HmYz$jsx)("div", {
                "aria-live": "assertive",
                children: errorMessage && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $e58ee6a643f23063$export$17503d092977c384), {
                    id: feilmeldingId,
                    children: errorMessage
                })
            })
        ]
    });
}
const $0d88376077b9c7c1$export$734ace74a9d87553 = $0d88376077b9c7c1$var$Component;


var $89f8763505b87200$exports = {};

$parcel$export($89f8763505b87200$exports, "SVVCheckbox", () => $89f8763505b87200$export$368d493d1adb06ac);


function $89f8763505b87200$var$Component({ id: id , label: label , description: description , description2: description2 , description3: description3 , ...rest }, ref) {
    const hasDescription = description !== undefined || description2 !== undefined || description3 !== undefined;
    const descriptionId = (0, $2HmYz$useId)();
    return /*#__PURE__*/ (0, $2HmYz$jsxs)((0, $2HmYz$Fragment), {
        children: [
            /*#__PURE__*/ (0, $2HmYz$jsx)("input", {
                type: "checkbox",
                id: id,
                ref: ref,
                ...rest
            }),
            /*#__PURE__*/ (0, $2HmYz$jsxs)("label", {
                className: `svv-form-label${hasDescription ? " svv-label-grid" : ""}`,
                htmlFor: id,
                children: [
                    /*#__PURE__*/ (0, $2HmYz$jsx)("span", {
                        children: label
                    }),
                    hasDescription && /*#__PURE__*/ (0, $2HmYz$jsxs)("span", {
                        id: descriptionId,
                        children: [
                            description && /*#__PURE__*/ (0, $2HmYz$jsx)("span", {
                                className: "svv-label-description",
                                children: description
                            }),
                            description2 && /*#__PURE__*/ (0, $2HmYz$jsx)("span", {
                                className: "svv-label-description",
                                children: description2
                            }),
                            description3 && /*#__PURE__*/ (0, $2HmYz$jsx)("span", {
                                className: "svv-label-description",
                                children: description3
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $89f8763505b87200$export$368d493d1adb06ac = /*#__PURE__*/ (0, $2HmYz$forwardRef)($89f8763505b87200$var$Component);


var $0bd9279aafa6edfe$exports = {};

$parcel$export($0bd9279aafa6edfe$exports, "SVVCheckboxGroup", () => $0bd9279aafa6edfe$export$e3e57f6e2b6a5c25);






function $0bd9279aafa6edfe$export$e3e57f6e2b6a5c25({ options: options , error: error , legend: legend , direction: direction , required: required , popoverText: popoverText , popoverTitle: popoverTitle , isFullWidth: isFullWidth , removeMargin: removeMargin = false , description: description  }) {
    const [errorMessageId] = (0, $2HmYz$useState)(`feilmelding-${(0, $2HmYz$useId)()}`);
    const hasPopover = popoverText && popoverTitle;
    return /*#__PURE__*/ (0, $2HmYz$jsxs)("fieldset", {
        className: (0, $2HmYz$classnames)("svv-form-element", {
            "svv-form-element--inline": direction === "horizontal",
            "svv-form-element--with-errors": error,
            "svv-form-element--max-width": !isFullWidth,
            "svv-form-element--margin-bottom": !removeMargin
        }),
        children: [
            /*#__PURE__*/ (0, $2HmYz$jsxs)("legend", {
                className: (0, $2HmYz$classnames)("svv-form-label", {
                    "svv-form-label--inline": hasPopover
                }),
                children: [
                    legend,
                    required && /*#__PURE__*/ (0, $2HmYz$jsx)("span", {
                        "aria-hidden": "true",
                        children: " *"
                    })
                ]
            }),
            hasPopover && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $14e7cb777ecf9dfd$export$8eb2fb0b97d123d3), {
                explanationText: popoverText,
                title: popoverTitle
            }),
            description && /*#__PURE__*/ (0, $2HmYz$jsx)("p", {
                className: "svv-form-description",
                children: description
            }),
            options.map((o)=>/*#__PURE__*/ (0, $2HmYz$jsx)((0, $89f8763505b87200$export$368d493d1adb06ac), {
                    onChange: o.onChange,
                    checked: o.checked,
                    ...error && errorMessageId && {
                        "aria-describedby": errorMessageId
                    },
                    ...o
                }, o.id)),
            /*#__PURE__*/ (0, $2HmYz$jsx)("div", {
                "aria-live": "assertive",
                children: error && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $e58ee6a643f23063$export$17503d092977c384), {
                    id: errorMessageId,
                    children: error
                })
            })
        ]
    });
}


var $1ea767d8c54bf014$exports = {};

$parcel$export($1ea767d8c54bf014$exports, "SVVSelect", () => $1ea767d8c54bf014$export$a83dbd1eeae3ba2);






function $1ea767d8c54bf014$var$Component({ selected: selected , options: options , legend: legend , emptyChoiceText: emptyChoiceText , id: id , errorMessage: errorMessage , required: required , selectSize: selectSize , popoverText: popoverText , popoverTitle: popoverTitle , removeMargin: removeMargin = false , isFullWidth: isFullWidth = false , description: description , ...rest }, ref) {
    const [errorMessageId] = (0, $2HmYz$useState)(`errormessage-${(0, $2HmYz$useId)()}`);
    const cssClass = (0, $2HmYz$classnames)("svv-form-input__select", {
        "input--x-small": selectSize === "xSmall",
        "input--small": selectSize === "small",
        "input--medium": selectSize === "medium",
        "svv-form-input__text--error": errorMessage
    });
    return /*#__PURE__*/ (0, $2HmYz$jsxs)("div", {
        className: (0, $2HmYz$classnames)("svv-form-element", {
            "svv-form-element--max-width": !isFullWidth,
            "svv-form-element--margin-bottom": !removeMargin
        }),
        children: [
            /*#__PURE__*/ (0, $2HmYz$jsx)((0, $25ca7d7dcfe715d6$export$7aa8239a4d00617e), {
                htmlFor: id,
                popoverTitle: popoverTitle,
                popoverText: popoverText,
                required: required,
                children: legend
            }),
            description && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $3360cc37f7f07341$export$393edc798c47379d), {
                content: description
            }),
            /*#__PURE__*/ (0, $2HmYz$jsxs)("select", {
                name: "bestill-for",
                id: id,
                value: selected,
                "aria-describedby": errorMessage ? errorMessageId : undefined,
                required: required,
                ref: ref,
                ...rest,
                ...errorMessage && {
                    className: "svv-form-input__text--error"
                },
                ...cssClass && {
                    className: cssClass
                },
                children: [
                    emptyChoiceText && /*#__PURE__*/ (0, $2HmYz$jsx)("option", {
                        value: "",
                        children: emptyChoiceText
                    }),
                    options.map((o)=>/*#__PURE__*/ (0, $2HmYz$jsx)("option", {
                            value: o.value,
                            ...o.disabled && {
                                disabled: true
                            },
                            children: o.text
                        }, o.value))
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $e58ee6a643f23063$export$17503d092977c384), {
                id: errorMessageId,
                children: errorMessage
            })
        ]
    });
}
const $1ea767d8c54bf014$export$a83dbd1eeae3ba2 = /*#__PURE__*/ (0, $2HmYz$forwardRef)($1ea767d8c54bf014$var$Component);


var $6919ce8c3c265f10$exports = {};

$parcel$export($6919ce8c3c265f10$exports, "SVVSelectOne", () => $6919ce8c3c265f10$export$afd2c91dd3a6f80c);




function $6919ce8c3c265f10$export$afd2c91dd3a6f80c({ onChange: onChange , options: options , selected: selected , legend: legend , required: required , errorMessage: errorMessage , id: id , direction: direction , selectSize: selectSize , emptyChoiceText: emptyChoiceText , name: name  }) {
    return options?.length > 5 ? /*#__PURE__*/ (0, $2HmYz$jsx)((0, $1ea767d8c54bf014$export$a83dbd1eeae3ba2), {
        onChange: onChange,
        options: options,
        selected: selected,
        legend: legend,
        id: id,
        required: required,
        errorMessage: errorMessage,
        selectSize: selectSize,
        emptyChoiceText: emptyChoiceText
    }) : /*#__PURE__*/ (0, $2HmYz$jsx)((0, $0d88376077b9c7c1$export$734ace74a9d87553), {
        onChange: onChange,
        options: options,
        selected: selected,
        legend: legend,
        required: required,
        errorMessage: errorMessage,
        id: id,
        name: name,
        direction: direction
    });
}


var $6047d6fe15928962$exports = {};

$parcel$export($6047d6fe15928962$exports, "SVVSearchField", () => $6047d6fe15928962$export$7dd06713b0ea4f65);







function $6047d6fe15928962$export$7dd06713b0ea4f65({ id: id , label: label , onSearch: onSearch , className: className , errorMessage: errorMessage , inputSize: inputSize = "medium" , placeholder: placeholder , required: required , popoverText: popoverText , popoverTitle: popoverTitle , searchText: searchText , buttonText: buttonText = "S\xf8k" , description: description , ...rest }) {
    const [errorMessageId] = (0, $2HmYz$useState)(`feilmelding-${(0, $2HmYz$useId)()}`);
    const hasErrorMessage = !!errorMessage;
    const [text, setText] = (0, $2HmYz$useState)(searchText || "");
    const handleSubmit = (e)=>{
        e.preventDefault();
        onSearch(text);
    };
    return /*#__PURE__*/ (0, $2HmYz$jsxs)("form", {
        className: (0, $2HmYz$classnames)("svv-search-field", className),
        onSubmit: handleSubmit,
        noValidate: true,
        children: [
            label && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $25ca7d7dcfe715d6$export$7aa8239a4d00617e), {
                htmlFor: id,
                required: required,
                popoverText: popoverText,
                popoverTitle: popoverTitle,
                children: label
            }),
            description && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $3360cc37f7f07341$export$393edc798c47379d), {
                content: description
            }),
            /*#__PURE__*/ (0, $2HmYz$jsxs)("div", {
                className: "svv-search-field__container",
                children: [
                    /*#__PURE__*/ (0, $2HmYz$jsx)("input", {
                        id: id,
                        className: (0, $2HmYz$classnames)("svv-form-input__text", {
                            "svv-form-input__text--error": hasErrorMessage,
                            "input--x-small": inputSize === "xsmall",
                            "input--small": inputSize === "small",
                            "input--medium": inputSize === "medium",
                            "input--large": inputSize === "large"
                        }),
                        placeholder: placeholder,
                        "aria-invalid": hasErrorMessage,
                        "aria-describedby": hasErrorMessage ? errorMessageId : undefined,
                        required: required,
                        type: "search",
                        onChange: (e)=>setText(e.target.value),
                        value: text,
                        ...rest
                    }),
                    /*#__PURE__*/ (0, $2HmYz$jsxs)("button", {
                        className: "svv-button",
                        type: "submit",
                        children: [
                            /*#__PURE__*/ (0, $2HmYz$jsx)((0, $2HmYz$Search), {}),
                            /*#__PURE__*/ (0, $2HmYz$jsx)("span", {
                                className: "svv-search-field__text",
                                children: buttonText
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2HmYz$jsx)("div", {
                "aria-live": "assertive",
                children: errorMessage && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $e58ee6a643f23063$export$17503d092977c384), {
                    id: errorMessageId,
                    children: /*#__PURE__*/ (0, $2HmYz$jsx)("p", {
                        children: errorMessage
                    })
                })
            })
        ]
    });
}


var $e8fef9c628fdbd25$exports = {};

$parcel$export($e8fef9c628fdbd25$exports, "SVVErrorSummary", () => $e8fef9c628fdbd25$export$8be309e2f0406236);


function $e8fef9c628fdbd25$export$8be309e2f0406236({ errorMessages: errorMessages , label: label  }) {
    return /*#__PURE__*/ (0, $2HmYz$jsxs)("div", {
        className: "svv-form-error-summary editorial",
        children: [
            /*#__PURE__*/ (0, $2HmYz$jsx)("p", {
                children: label
            }),
            /*#__PURE__*/ (0, $2HmYz$jsx)("ul", {
                children: errorMessages.map((m)=>/*#__PURE__*/ (0, $2HmYz$jsx)("li", {
                        children: /*#__PURE__*/ (0, $2HmYz$jsx)("a", {
                            href: `#${m.id}`,
                            className: "svv-form-error-summary--link",
                            children: m.errorMessage
                        })
                    }, m.id))
            })
        ]
    });
}



var $a044aaf1f14d5a91$exports = {};

$parcel$export($a044aaf1f14d5a91$exports, "SVVTextArea", () => $a044aaf1f14d5a91$export$ee08ece6726e4b87);







function $a044aaf1f14d5a91$var$Component({ className: className , errorMessage: errorMessage , label: label , placeholder: placeholder , id: id , required: required , maxLength: maxLength , maxLengthHelperText: maxLengthHelperText = "maks antall tegn er " , maxLengthWarning: maxLengthWarning = " tegn igjen til maks er n\xe5dd." , value: value , onChange: onChange , popoverText: popoverText , popoverTitle: popoverTitle , isFullWidth: isFullWidth = false , description: description , hideWarning: hideWarning = false , ...rest }, ref) {
    const [errorMessageId] = (0, $2HmYz$useState)(`feilmelding-${(0, $2HmYz$useId)()}`);
    const hasErrorMessage = !!errorMessage;
    const maxLengthLabel = maxLength ? `(${maxLengthHelperText} ${maxLength})` : "";
    const warningNumber = maxLength ? maxLength - 10 : null;
    const handleChange = (e)=>{
        onChange(e);
    };
    (0, $2HmYz$useEffect)(()=>{}, [
        ref
    ]);
    return /*#__PURE__*/ (0, $2HmYz$jsxs)("div", {
        className: (0, $2HmYz$classnames)("svv-form-element", {
            "svv-form-element--max-width": !isFullWidth
        }, className),
        children: [
            label && /*#__PURE__*/ (0, $2HmYz$jsxs)((0, $25ca7d7dcfe715d6$export$7aa8239a4d00617e), {
                htmlFor: id,
                required: required,
                popoverTitle: popoverTitle,
                popoverText: popoverText,
                children: [
                    label,
                    " ",
                    maxLengthLabel
                ]
            }),
            description && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $3360cc37f7f07341$export$393edc798c47379d), {
                content: description
            }),
            /*#__PURE__*/ (0, $2HmYz$jsx)("textarea", {
                id: id,
                className: (0, $2HmYz$classnames)("svv-form-input__text", {
                    "svv-form-input__text--error": hasErrorMessage
                }),
                placeholder: placeholder,
                ref: ref,
                "aria-invalid": hasErrorMessage,
                "aria-describedby": hasErrorMessage ? errorMessageId : undefined,
                required: required,
                value: value,
                onChange: handleChange,
                ...rest
            }),
            maxLengthHelperText && maxLength && /*#__PURE__*/ (0, $2HmYz$jsx)("div", {
                children: /*#__PURE__*/ (0, $2HmYz$jsxs)("p", {
                    children: [
                        value.length,
                        "/",
                        maxLength
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2HmYz$jsx)("div", {
                "aria-live": "assertive",
                children: errorMessage && /*#__PURE__*/ (0, $2HmYz$jsx)((0, $e58ee6a643f23063$export$17503d092977c384), {
                    id: errorMessageId,
                    children: /*#__PURE__*/ (0, $2HmYz$jsx)("p", {
                        children: errorMessage
                    })
                })
            }),
            /*#__PURE__*/ (0, $2HmYz$jsx)("div", {
                children: !hideWarning && warningNumber && maxLength && !errorMessage && value.length > maxLength - 10 && /*#__PURE__*/ (0, $2HmYz$jsxs)((0, $2HmYz$SVVAlert), {
                    type: "info",
                    children: [
                        maxLength - value.length,
                        " ",
                        maxLengthWarning
                    ]
                })
            })
        ]
    });
}
const $a044aaf1f14d5a91$export$ee08ece6726e4b87 = /*#__PURE__*/ (0, $2HmYz$forwardRef)($a044aaf1f14d5a91$var$Component);




export {$2824c2d2eb112f7e$export$9a9ecced0a4bade6 as SVVTextInput, $25ca7d7dcfe715d6$export$7aa8239a4d00617e as SVVLabel, $e58ee6a643f23063$export$17503d092977c384 as SVVFormError, $7393724a49d31a75$export$d7b12c4107be0d61 as Radio, $0d88376077b9c7c1$export$734ace74a9d87553 as SVVRadioGroup, $89f8763505b87200$export$368d493d1adb06ac as SVVCheckbox, $0bd9279aafa6edfe$export$e3e57f6e2b6a5c25 as SVVCheckboxGroup, $1ea767d8c54bf014$export$a83dbd1eeae3ba2 as SVVSelect, $6919ce8c3c265f10$export$afd2c91dd3a6f80c as SVVSelectOne, $6047d6fe15928962$export$7dd06713b0ea4f65 as SVVSearchField, $e8fef9c628fdbd25$export$8be309e2f0406236 as SVVErrorSummary, $14e7cb777ecf9dfd$export$8eb2fb0b97d123d3 as SVVPopover, $a044aaf1f14d5a91$export$ee08ece6726e4b87 as SVVTextArea};
//# sourceMappingURL=module.js.map
